/* global process */
import React, { Component } from 'react';
import mixpanel from 'mixpanel-browser';
import { STATUS, API, decrypt, parseQueryString, jsonToQueryString } from '@vezeeta/web-utils';
import {
  Title,
  Subheading,
  Button,
  Spinner,
} from '@vezeeta/web-components';
import Cookie from 'js-cookie';
import configurations from '../payment/Config';
import './Confirmation.scss';
import { deleteCookies, detectCultureFromDoctorUrl, getDomain } from '../../shared/payment-utils';
import SuccessIcon from './icons/Green_Success.svg';
import FailureIcon from './icons/Red_Failed.svg';

const encryptionKey = 'MadMed117';

class Confirmation extends Component {
  constructor() {
    super();
    this.state = {
      paymentSuccess: false,
      paymentMessage: '',
      instructionsMessage: '',
      buttonText: '',
      isCheckingPayment: true,
      showButton: false,
    };
    this.PaymentAuthHeaders = [
      {
        key: 'x-vzt-Component',
        value: 'paymentportal',
      },
      {
        key: 'x-vzt-authorization',
        value: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBpZCI6InNlcnZpY2VzIiwiZXhwIjoxNTI0NDE0MDkxLjAsIm5uYyI6IjU4MDllYmIyYWQ2YjdmMmMifQ.lcVf-afeEm8KIpqFaMT3Y7hpyrPWg6fNic8Ew9YyU6k',
      },
    ];
  }

  componentDidMount() {
    if (Cookie.get('PaymentType') === 'reservation') {
      this.CultureLanguage = detectCultureFromDoctorUrl(Cookie.get('CallBack'));
      this.vezeetaUrl = getDomain(Cookie.get('CallBack'), true);
      this.reservationKey = Cookie.get('RK');
      this.useFullPathUrl = Cookie.get('useFullPathUrl');
      this.fullPathCallBackUrl = Cookie.get('fullPathCallBackUrl');
    } else {
      this.CultureLanguage = {
        LanguageId: 1,
        culture: 'en-US',
        RedirectCulture: '/en/',
      };
    }
    this.cookies = ['CD', 'AK', 'TK', 'RK', 'CID', 'PTK', 'CallBack', 'VezeetaUrl', 'BookingCallBack', 'LogoClickStatus', 'callBackAttributes', 'callbackHost', 'callbackRelativePath', 'RKcallbackQuery'];
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    mixpanel.identify(Cookie.get('PhoneNumber'));
    const urlToParse = window.location.search;
    const result = parseQueryString(urlToParse);
    window.history.replaceState(null, null, window.location.pathname);
    const isRedirected = window.location.pathname.includes('redirected');
    let chargeUrl;
    if (!isRedirected) {
      result.currencyid = Cookie.get('CID');
      result.accountkey = decrypt(Cookie.get('AK'), encryptionKey);
      result.paymenttypekey = decrypt(Cookie.get('PTK'), encryptionKey);
      result.componentkey = 'ACCMNGNT';
      result.countryid = Cookie.get('CD');
      result.payerkey = decrypt(Cookie.get('AK'), encryptionKey);
      result.payeekey = 'payeekey';
      result.secure3dreturnurl = configurations.secure3dreturnurl;

      chargeUrl = configurations.chargeAndUpdateUrl;
    } else {
      result.accountkey = decrypt(Cookie.get('AK'), encryptionKey);
      result.componentkey = 'ACCMNGNT';
      result.countryid = Cookie.get('CD');
      result.payerkey = decrypt(Cookie.get('AK'), encryptionKey);
      result.payeekey = 'payeekey';
      result.merchant_extra = Cookie.get('TK');

      chargeUrl = configurations.chargeUrl;
    }
    const chargeAccount = new API();
    chargeAccount
      .get(`${chargeUrl}${jsonToQueryString(result)}`, this.PaymentAuthHeaders)
      .then((response) => {
        if (
          response.status === STATUS.SUCCESS ||
          response.status === STATUS.CREATED
        ) {
          if (response.data.Secure3dUrl) {
            window.location = response.data.Secure3dUrl;
          } else if (response.data.Status === 1) {
            this.setState({
              showButton: true,
            });
            this.markAsSuccess(
              'Payment Successful!',
              'We have received your payment successfully and confirmed the reservation',
            );
          } else {
            this.markAsFailure(
              'Payment Declined!',
              'Unfortunately, We were not able to process your payment. Please try again',
            );
          }
        } else {
          this.markAsFailure(
            'Payment Declined!',
            'Unfortunately, We were not able to process your payment. Please try again',
          );
        }
      })
      .catch(() => {
        this.setState({
          showButton: true,
        });
        this.markAsFailure(
          'Payment Declined!',
          'Unfortunately, We were not able to process your payment. Please try again',
        );
      });
  }

  onSubmit = () => {
    if (this.state.paymentSuccess) {
      if (Cookie.get('RK') === 'sponsoredBid') {
        const callBackURL = Cookie.get('CallBack');
        window.location.href = callBackURL;
      } else {
        mixpanel.track('Payment Portal Continue Button', {
          Payment: 'Credit Card Payment Succeeded',
          Action: 'Advance To vezeeta thank you page',
        });
        const host = Cookie.get('callbackHost') ? `${Cookie.get('callbackHost')}` : `//${this.vezeetaUrl}`;
        const locale = this.CultureLanguage.RedirectCulture;
        const relativePath = Cookie.get('callbackRelativePath') || configurations.successUrl;
        const reservationKey = Cookie.get('RKcallbackQuery') ? Cookie.get('RK') : this.reservationKey;
        const useFullPathUrl = Cookie.get('useFullPathUrl') ? Cookie.get('useFullPathUrl') : this.useFullPathUrl;
        const fullPathCallBackUrl = Cookie.get('fullPathCallBackUrl') ? Cookie.get('fullPathCallBackUrl') : this.fullPathCallBackUrl;
        let fullPath = '';
        useFullPathUrl === 'true' ? fullPath = fullPathCallBackUrl : fullPath = host + locale + relativePath;
        deleteCookies(this.cookies);
        window.location.replace(fullPath + (reservationKey ? `?key=${reservationKey}` : ''));
      }
    } else {
      mixpanel.track('Payment Portal Try Again Button', {
        Payment: 'Credit Card Payment Failed',
        Action: 'Try another credit card in payment portal',
      });
      mixpanel.track('Payment Portal Page');
      window.location.pathname = '/';
    }
  };

  stateCallBack = (state) => {
    if (Cookie.get('PaymentType') !== 'reservation') {
      if (state === false) {
        deleteCookies(this.cookies);
        window.location.replace(`//${this.vezeetaUrl}`);
      }
    }
  };

  returnToVezeetaDoctorProfile = async () => {
    mixpanel.track('Payment Portal Return to doctor profile Button', {
      Payment: 'Credit Card Payment Failed',
      Action: 'Return to doctor profile in Vezeeta',
    });
    this.stateCallBack(false);
    if (Cookie.get('PaymentType') === 'reservation') {
      const cancelReservationUrl = configurations.cancelReservationUrl;
      const cancelReservationAttributes = {
        reservationKey: Cookie.get('RK'),
      };
      await fetch(`${cancelReservationUrl}${jsonToQueryString(cancelReservationAttributes)}`, {
        method: 'PATCH',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          CountryId: Cookie.get('CD'),
          Language: 'en-US',
        },
      });
      const CallBack = Cookie.get('CallBack');
      deleteCookies(this.cookies);
      window.location.replace(CallBack);
    } else {
      deleteCookies(this.cookies);
      window.location.replace(this.vezeetaUrl);
    }
  };

  markAsFailure = (title, message) => {
    this.setState({
      paymentSuccess: false,
      paymentMessage: title,
      instructionsMessage: message,
      buttonText: 'Try again',
      isCheckingPayment: false,
    });
    mixpanel.track('Credit Card Payment', {
      Payment: 'Credit Card Payment Failed',
      Action: 'Show Failure Page',
      Reason: 'Invalid Data From User',
    });
  };

  markAsSuccess = (title, message) => {
    this.setState({
      paymentSuccess: true,
      paymentMessage: title,
      instructionsMessage: message,
      buttonText: 'Continue',
      isCheckingPayment: false,
    });
    Cookie.set('LogoClickStatus', false, {
      expires: 1 / (24 * 4),
    });
    mixpanel.track('Credit Card Payment', {
      Payment: 'Credit Card Payment Succeeded',
      Action: 'Show Success Page',
    });
    setTimeout(() => {
      this.onSubmit();
    }, 5000);
  };

  render() {
    const amountPaid = Cookie.get('amountPaid');
    const isPartialPayment = amountPaid && parseFloat(amountPaid) && parseFloat(amountPaid) > 0;
    let displayOnState;
    let status;
    let returnText = isPartialPayment ? 'Cancel and Refund' : 'Back';
    if (Cookie.get('PaymentType') === 'queueing') {
      returnText = 'Return to Vezeeta';
    }
    if (this.state.paymentSuccess) {
      displayOnState = {
        display: 'none',
      };
      status = (
        <div className="center status-container success-container">
          <img
            alt="Success Icon"
            src={SuccessIcon}
            width="120px"
          />
        </div>
      );
    } else {
      displayOnState = {
        display: 'block',
      };
      status = (
        <div className="center status-container danger-container">
          <img
            alt="Failure Icon"
            src={FailureIcon}
            width="120px"
          />
        </div>
      );
    }

    let components;
    if (this.state.isCheckingPayment) {
      components = (
        <div className="center centerVertically flex-col">
          <Spinner />
          <Title className="loading-text">Charging your account</Title>
        </div>
      );
    } else {
      components = (
        <div className="center centerVertically flex-col">
          {status}
          <Title className="message">{this.state.paymentMessage}</Title>
          <Subheading className="instructions">
            {this.state.instructionsMessage}
          </Subheading>
          <div className="small-fields">
            {this.state.showButton && (
              <Button type="red" onClick={this.onSubmit} className="margin-20">
                {this.state.buttonText}
              </Button>
            )}
            <div style={displayOnState}>
              <Button
                type="blue"
                onClick={this.returnToVezeetaDoctorProfile}
                className="margin-20"
              >
                {returnText}
              </Button>
            </div>
          </div>
          {this.state.paymentSuccess === false && isPartialPayment > 0 && <p>{'We\'ll refund you the amounts paid by Qitaf if you click on "Cancel and Refund". It should reflect in your Qitaf account within 7-14 days.'}</p>}
        </div>
      );
    }
    return (
      <div className="card-container center confirmation-container">
        {components}
      </div>
    );
  }
}

export default Confirmation;



// WEBPACK FOOTER //
// ./src/views/confirmation/Confirmation.js